import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Capacitor } from '@capacitor/core';
import { RequireComponent } from '../components/require/require.component';
import { PasswordChangeComponent } from '../components/require/password-change/password-change.component';
import { DetailsComponent } from '../components/require/details/details.component';
import { TncComponent } from '../components/require/tnc/tnc.component';
import { EmailVerificationComponent } from '../components/require/email-verification/email-verification.component';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  static tncRequiredOpen = false
  static emailVerificationRequiredOpen = false
  static detailsRequiredOpen = false
  static passwordChangeRequiredOpen = false

  constructor(private authService: AuthService,
    private router: Router,
    private modalService: NgbModal
  ) { }

  static resetRequired() {
    AuthInterceptor.detailsRequiredOpen = false
    AuthInterceptor.passwordChangeRequiredOpen = false
    AuthInterceptor.tncRequiredOpen = false
    AuthInterceptor.emailVerificationRequiredOpen = false
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const authToken = this.authService.getToken();

    req = req.clone({
      setHeaders: {
        'Authorization': `Bearer ${authToken}`,
        'Accept-Language': `${$localize.locale}`,
        'X-Cronox-Build': environment.version + ' ' + Capacitor.getPlatform()
      }
    });

    return next.handle(req).pipe(catchError((error: HttpErrorResponse) => {
      let message = error.error.message;

      if (error.status === 401) {
        this.router.navigate(['/signin']);
      }
      else if (error.status === 403) {
        if (error.headers.get('x-require') == 'tnc' && AuthInterceptor.tncRequiredOpen === false) {
          AuthInterceptor.tncRequiredOpen = true

          const modal = this.modalService.open(RequireComponent, { fullscreen: true, keyboard: false, scrollable: true })

          modal.componentInstance.childComponent = TncComponent
        }

        else if (error.headers.get('x-require') == 'email_verification' && AuthInterceptor.emailVerificationRequiredOpen === false) {
          AuthInterceptor.emailVerificationRequiredOpen = true

          const modal = this.modalService.open(RequireComponent, { fullscreen: true, keyboard: false, scrollable: true })

          modal.componentInstance.childComponent = EmailVerificationComponent
        }

        else if (error.headers.get('x-require') == 'password_change' &&AuthInterceptor.passwordChangeRequiredOpen === false) {
          AuthInterceptor.passwordChangeRequiredOpen = true

          const modal = this.modalService.open(RequireComponent, { fullscreen: true, keyboard: false, scrollable: true })

          modal.componentInstance.childComponent = PasswordChangeComponent
        }

        else if (error.headers.get('x-require') == 'details' && AuthInterceptor.detailsRequiredOpen === false) {
          AuthInterceptor.detailsRequiredOpen = true
          const modal = this.modalService.open(RequireComponent, { fullscreen: true, keyboard: false, scrollable: true })

          modal.componentInstance.childComponent = DetailsComponent
        }
      }
      else if (error.status === 504) {
        alert($localize`Can't connect to server.`)
      }
      else if (message) {
        alert($localize`Error: ` + message)
      }

      return throwError(() => error);
    }))
  }
}
